import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitFxItem } from '../models/jg/jg-physical-insp-unit-fx-item.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitFxItemService extends RequestService<JgPhysicalInspUnitFxItem> {
  static PATH = '/jg/physicalInsp/unitFx/item';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgPhysicalInspUnitFxItemService.PATH,
      globalService.debugUrl,
    );
  }
}
